import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PdfViewer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const pdfUrl = queryParams.get('url');
    const title = queryParams.get('title') || 'Book Viewer';

    useEffect(() => {
        // Set Document Title
        document.title = title;

        // Handle Favicon
        const link = document.querySelector("link[rel~='icon']");
        const originalHref = link ? link.getAttribute('href') : '/assets/darulLogo.png';

        if (link) {
            // Option 1: Set to specific icon
            link.href = '/assets/darulLogo.png';

            // Option 2: To have "no icon" (uncomment below)
            // link.href = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        }

        // Restore on unmount
        return () => {
            document.title = 'DarulHadees';
            if (link) link.href = originalHref;
        };
    }, [title]);

    if (!pdfUrl) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-100 italic text-gray-500">
                No PDF file specified.
            </div>
        );
    }

    return (
        <div className="fixed inset-0 w-full h-full z-[100] bg-white flex flex-col">
            {/* PDF Content - removed #toolbar=0 to show native browser tools */}
            <div className="flex-1 w-full h-full relative">
                <iframe
                    src={pdfUrl}
                    className="w-full h-full border-none"
                    title={title}
                />
            </div>
        </div>
    );
};

export default PdfViewer;
